import { render, staticRenderFns } from "./StaffRole.vue?vue&type=template&id=1e5b3e54&scoped=true"
import script from "./StaffRole.vue?vue&type=script&lang=js"
export * from "./StaffRole.vue?vue&type=script&lang=js"
import style0 from "./StaffRole.vue?vue&type=style&index=0&id=1e5b3e54&prod&scoped=true&lang=css"
import style1 from "./StaffRole.vue?vue&type=style&index=1&id=1e5b3e54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b3e54",
  null
  
)

export default component.exports